<template>
    <DefaultAside @okHandler="onSubmit" :title="target.title">
        <b-form id="form-target-comment" novalidate>
            <b-form-textarea
                autofocus
                :placeholder="$t('targetEvaluation.commentPlaceholder')"
                rows="5"
                max-rows="8"
                v-model.trim="commentText"
            ></b-form-textarea>
        </b-form>
        <template slot="okButton">
            <i v-if="isSubmitting" class="fa fa-spinner fa-spin px-2"></i>
        </template>
    </DefaultAside>
</template>

<script>
import DefaultAside from '@/containers/DefaultAside'
import notification, { success, danger } from '@/lib/notification'
import { commentGoal } from './api'

notification.init()

export default {
    name: 'TargetEvaluationAside',
    props: ['target'],
    components: {
        DefaultAside,
    },
    data() {
        return {
            selectedRange: null,
            commentText: null,
            isSubmitting: false,
            ranges: [],
        }
    },
    methods: {
        async onSubmit(closeAside) {
            if (!this.commentText) return

            this.isSubmitting = true

            try {
                const result = await commentGoal(
                    this.target.id,
                    this.commentText
                )

                closeAside(result)

                success()
            } catch (error) {
                danger()
            } finally {
                this.isSubmitting = false
            }
        },
    },
}
</script>
